import { Text, View } from '@react-pdf/renderer';

/**
 *
 * @exports DocumentSeller
 *
 * @description Document seller component
 *
 * @param { Object } props
 *
 * @param { Object } props.contacts
 *
 * @param { Object } props.legalData
 *
 * @returns { JSX.Element }
 *
 */

export default function DocumentSeller ( { contacts, legalData } ) {

    /**
     *
     * @description
     *
     * Use legalData if available, otherwise fall back to contacts
     *
     */

    const companyName = legalData?.legalEntityName || "Tireshop SIA";
    const regNr = legalData?.registrationNumber || contacts?.regNr || "-";
    const address = contacts?.address || legalData?.legalAddress || legalData?.factualAddress || "-";

    // Get enabled bank accounts, or fall back to legacy fields
    const enabledBankAccounts = legalData?.bankAccounts?.filter(account => account.isEnabled) || [];
    const bankName = enabledBankAccounts.length > 0 ? null : (legalData?.bankName || contacts?.bank || "-");
    const accountNumber = enabledBankAccounts.length > 0 ? null : (legalData?.accountNumber || contacts?.bankAccountNumber || "-");

    /**
     *
     * @description
     *
     * Render seller component
     *
     * @returns { JSX.Element }
     *
     */

    return (

        <View style={ { gap: 5 } }>

            <View>

                <Text style={ { fontWeight: 500 } }>Pārdevējs:</Text>

            </View>

            <View>

                <Text>{ companyName }</Text>

                <Text>Reģ. nr.: { regNr }</Text>

                <Text>PVN reģ. nr.: LV{ regNr }</Text>

                <Text>{ address }</Text>

            </View>

            { enabledBankAccounts.length > 0 ? (

                enabledBankAccounts.map((account, index) => (

                    <View key={ index }>

                        <Text>Banka: { account.bankName }</Text>

                        <Text>Konts: { account.iban }</Text>

                        { account.swiftCode && <Text>SWIFT: { account.swiftCode }</Text> }

                    </View>

                ))

            ) : (

                <View>

                    <Text>Banka: { bankName }</Text>

                    <Text>Konts: { accountNumber }</Text>

                </View>

            ) }

        </View>

    );

};